import { getSlaughterWeightProjection } from '@/services/slaughter';

export const actions = {
  async loadSlaughterWeightProjection({ rootGetters, commit }, { batch_id }) {
    const token = rootGetters['user/getToken'];
    let response = await getSlaughterWeightProjection(token.access, batch_id);

    let slaughterWeightProjection = [];
    if (response.results) {
      slaughterWeightProjection = response.results.predictions;
    }
    commit('SET_SLAUGHTER_WEIGHT_PROJECTION', slaughterWeightProjection);
  },
};
